import request from '/@common/utils/request';



//生成收款二维码
export function preCreat(data: object) {
	return request({
		url: '/api/pay/preCreat',
		method: 'get',
		params: data,
	});
}
//查询支付状态
export function isPayComplete(data: object) {
	return request({
		url: `/api/pay/isPayComplete/${data.payType}/${data.tradeNo}`,
		method: 'get',
	});
}
//查询充值明细
export function pagePayRecord(data: object) {
	return request({
		url: `/api/pay/pagePayRecord`,
		method: 'post',
		data
	});
}
//用户更新资料-电话、Emil、名称
export function editUser(data: object) {
	return request({
		url: '/api/user/editUser',
		method: 'post',
		data,
	});
}

//绑定企微
export function bindWxUser(data: object) {
	return request({
		url: '/api/user/bindWxUser',
		method: 'post',
		data,
	});
}

//时间范围内统计某个技能类别下的某个技能的调用次数和token
export function getSkillDetailCountAndToken(data: object) {
	return request({
		url: '/api/overview/getSkillDetailCountAndToken',
		method: 'post',
		data,
	});
}
//某个技能类别下的某个技能的调用次数和token
export function getSkillCategoryCount() {
	return request({
		url: '/api/app/listAppCategory',
		method: 'get',
	});
}
//时间范围内统计某个技能类别下的某个技能的调用次数和token
export function getSkillCategoryCountTime(data: object) {
	return request({
		url: '/api/overview/v3/getSkillCategoryCount',
		method: 'post',
		data,
	});
}
//时间范围内统计某个技能类别下的某个技能的调用次数和token
export function getSkillCount(data: object) {
	return request({
		url: '/api/overview/getSkillCount',
		method: 'post',
		data,
	});
}
//获取余额以及充值情况
export function getPersonagePrice(isFirstPay: boolean) {
	return request({
		url: `/api/user/getPersonagePrice/${isFirstPay}`,
		method: 'get',
	});
}
//最近消费
export function recentConsumptionApi(data: object) {
	return request({
		url: '/api/overview/recentConsumption',
		method: 'post',
		data
	});
}

//消费明细
export function pageConsume(data: object) {
	return request({
		url: '/api/consume/pageConsume',
		method: 'post',
		data
	});
}

//余额警告
export function notice() {
	return request({
		url: '/api/overview/notice',
		method: 'get',
	});
}

//技能类别列表
export function listAppCategory() {
	return request({
		url: '/api/app/listAppCategory',
		method: 'get',
	});
}
//技能类别列表
export function payExport(data: object) {
	return request({
		url: '/api/pay/export',
		method: 'post',
		responseType:'blob',
		data
	});
}
//支付类型列表
export function listPayType() {
	return request({
		url: '/api/pay/listPayType',
		method: 'get',
	});
}
//支付类型列表
export function listPayStatus() {
	return request({
		url: '/api/pay/listPayStatus',
		method: 'get',
	});
}
//用户类型列表
export function listPayUserType() {
	return request({
		url: '/api/pay/listPayUserType',
		method: 'get',
	});
}
//服务收费策略
export function serviceChargePolicy() {
	return request({
		url: '/api/auth/serviceChargePolicy',
		method: 'get',
	});
}

//更新余额警告状态
export function updateStatusByNoticeId(noticeId: string) {
	return request({
		url: `/api/overview/updateStatusByNoticeId/${noticeId}`,
		method: 'get',
	});
}
